<template>
  <div class="admin vehicles">
    <AdminHeader />
    <div class="row">
      <div class="col-3">
        <div class="row">
          <div class="col-12 row-header">Vehicles</div>
        </div>
        <div class="scrolling-table" v-show="!loading">
          <template v-for="item in vehicles">
            <div
              class="row clickable"
              :key="item.id"
              v-show="item.active == !show_deleted"
              v-bind:class="{ selected: item == vehicle }"
              @click="_vehicleSelected(item)"
            >
              <div class="col-12">
                {{ item.name }}
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="col-9">
        <div class="row">
          <VehicleDetail
            :vehicle="vehicle"
            class="col-12"
            ref="vehicle_detail"
            @new="_new_vehicle"
          />
        </div>
      </div>
    </div>
    <NewVehicleModal
      v-show="showNewVehicleModal"
      ref="new_vehicle_modal"
      @close="_closeNewVehicleModal"
    />
    <div class="row">
      <div class="col-3">
        <input type="checkbox" id="show_deleted" @click="_show_deleted" />
        <label for="show_deleted">Show Deleted</label>
      </div>
    </div>
  </div>
</template>

<script>
import AdminHeader from "@/components/admin/AdminHeader.vue";
import VehicleDetail from "@/components/admin/vehicle/VehicleDetail.vue";
import NewVehicleModal from "@/components/admin/vehicle/NewVehicleModal.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "Vehicles",
  data: () => ({
    vehicle: null,
    loading: false,
    show_deleted: false,
    showNewVehicleModal: false,
  }),
  computed: {
    ...mapState("vehicles", ["vehicles", "new_vehicle"]),
  },
  watch: {
    new_vehicle(new_value) {
      this.vehicle = new_value;
      this.$refs.new_vehicle_modal.clear();
    },
  },
  methods: {
    ...mapActions("vehicles", ["apiSaveVehicle", "apiCreateVehicle"]),
    _show_deleted() {
      this.show_deleted = !this.show_deleted;
    },
    _save() {
      this.$refs.vehicle_detail.save();
    },
    _new_vehicle() {
      this.showNewVehicleModal = true;
    },
    _closeNewVehicleModal() {
      this.showNewVehicleModal = false;
    },
    _showTab(index) {
      this.tab = index;
    },
    _vehicleSelected(vehicle) {
      this.vehicle = vehicle;
    },
    _delete_vehicle() {
      if (this.vehicle != null && this.vehicle.id > 0) {
        this.vehicle.active = !this.vehicle.active;
        this.apiSaveVehicle(this.vehicle);
      }
    },
  },
  components: {
    AdminHeader,
    VehicleDetail,
    NewVehicleModal,
  },
};
</script>
